import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AdalService } from './service';

@Component({
	templateUrl: 'inactive-modal.component.html'
})

export class InactiveModalComponent implements OnInit, OnDestroy {
	@Input() countNum;
	public counter; // inactive start 15 mins
	public counterExt = 'minutes';
	private timer1: NodeJS.Timer;
	constructor(
		public activeModal: NgbActiveModal,
		private adalService: AdalService,
		private router: Router) { }

	ngOnInit() {
		this.counter = this.countNum;
		this.timer1 = setInterval(() => {
			// console.log(this.counter);
			this.counter--;
			if (this.counter < 60) {
				this.counterExt = 'minute';
			}
			if (this.counter === 1) {
				this.counterExt = 'second';
			}
			if (this.counter === 0) {
				// clearInterval(this.timer1);
				this.adalService.logout();
				this.router.navigate(['logout']);
				// console.log('Ding!');
			}
		}, 1000);
	}

	ngOnDestroy() {
		clearInterval(this.timer1);
	}

	cancel() {
		this.activeModal.close('cancel');
	}
}
